// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/scenario.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message knop.ui.v1.api.ScenarioRequest
 */
export class ScenarioRequest extends Message<ScenarioRequest> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  constructor(data?: PartialMessage<ScenarioRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.ScenarioRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ScenarioRequest {
    return new ScenarioRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ScenarioRequest {
    return new ScenarioRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ScenarioRequest {
    return new ScenarioRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ScenarioRequest | PlainMessage<ScenarioRequest> | undefined, b: ScenarioRequest | PlainMessage<ScenarioRequest> | undefined): boolean {
    return proto3.util.equals(ScenarioRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.ScenarioResponse
 */
export class ScenarioResponse extends Message<ScenarioResponse> {
  /**
   * @generated from field: google.protobuf.Timestamp scenario_start = 1;
   */
  scenarioStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp scenario_end = 2;
   */
  scenarioEnd?: Timestamp;

  /**
   * @generated from field: string instance_id = 3;
   */
  instanceId = "";

  /**
   * @generated from field: string location = 4;
   */
  location = "";

  /**
   * @generated from field: bool is_solved_by_hip = 5;
   */
  isSolvedByHip = false;

  constructor(data?: PartialMessage<ScenarioResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.ScenarioResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scenario_start", kind: "message", T: Timestamp },
    { no: 2, name: "scenario_end", kind: "message", T: Timestamp },
    { no: 3, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_solved_by_hip", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ScenarioResponse {
    return new ScenarioResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ScenarioResponse {
    return new ScenarioResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ScenarioResponse {
    return new ScenarioResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ScenarioResponse | PlainMessage<ScenarioResponse> | undefined, b: ScenarioResponse | PlainMessage<ScenarioResponse> | undefined): boolean {
    return proto3.util.equals(ScenarioResponse, a, b);
  }
}

